export default {
  setInfo(state, o) {
  	state.test = o
  }
}
